/* eslint-disable no-unused-vars */
export enum ESession {
    JWT = 'fcm_token',
    USER = 'p-user',
    WORKSPACE = 'p-workspace',
    MUST_ANSWER_QUESTION = 'p-must-answer-question',
}

export enum ERole {
    DELIVERY_PARTNER = 'deliveryPartner',
    ADMIN = 'admin',
    BUSINESS = 'business',
}
